import React, { useState } from 'react';
import styles from './FAQPage.module.css';

const faqs = [
  {
    category: "Getting Started",
    questions: [
      {
        q: "What exactly does LeanWeek-AI do?",
        a: "LeanWeek-AI is a localized fitness architect. You input your biometrics, available equipment, and goals, and our AI engine generates a structured, day-by-day workout and movement plan for the next 7 days. It removes the guesswork from fat loss and sustainable fitness."
      },
      {
        q: "Do I need to create an account?",
        a: "No. LeanWeek-AI is built on a local-first architecture. You do not need to provide an email, create a password, or sign up for an account to start generating your weekly plans."
      },
      {
        q: "Is this app suitable for beginners?",
        a: "Absolutely. The AI adjusts the volume and intensity based on your experience level. Every generated workout includes step-by-step instructions, rep ranges, and rest timers so you always know exactly what to do."
      }
    ]
  },
  {
    category: "Privacy & Data",
    questions: [
      {
        q: "Is my health data private?",
        a: "Yes. Your weight, age, and fitness goals are processed to create your plan, but they are stored entirely on your device. We do not have a central database of your biometrics, and we do not sell your data."
      },
      {
        q: "How do I delete my data?",
        a: "Because your data lives on your phone, you are in total control. You can wipe all your information instantly by using the 'Reset All Data' button in the app settings, or simply by deleting the app from your device."
      }
    ]
  },
  {
    category: "Features & Workouts",
    questions: [
      {
        q: "Do I need a gym membership?",
        a: "No. When setting up your week, you tell the app what equipment you have. Whether you are using a full commercial gym, a pair of dumbbells at home, or just your own body weight, the AI will build a plan that fits your environment."
      },
      {
        q: "Does the app sync my steps automatically?",
        a: "Currently, you log your steps during your Daily Check-In. However, automatic background syncing with Apple Health (HealthKit) and Google Fit is currently in development and will be available in an upcoming update."
      },
      {
        q: "Can I export my weekly plans?",
        a: "Yes. You can export your entire 7-day schedule as a clean, printable PDF document so you can take it to the gym without needing to look at your phone."
      },
      {
        q: "Can I share my progress on social media?",
        a: "Yes. The app generates beautiful, high-contrast 'Morning Preview' and 'Evening Recap' cards. These are perfectly sized for Instagram Stories or sending to an accountability partner."
      },
      {
        q: "Does LeanWeek-AI provide medical advice?",
        a: "No. LeanWeek-AI is a tool for general fitness and fat-loss support. It does not diagnose, treat, or guarantee specific results. Always consult a healthcare professional before starting a new exercise or diet program."
      }
    ]
  },
  {
    category: "Upgrades & Premium",
    questions: [
      {
        q: "What do I get with LeanWeek Premium?",
        a: "The free tier gives you one complete 7-day plan per week. Premium unlocks unlimited AI regenerations (perfect if your schedule changes mid-week), exercise swapping, premium export themes, and advanced historical tracking."
      }
    ]
  }
];

const FAQPage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className={styles.page}>
      <header className={styles.hero}>
        <div className={styles.container}>
          <h1>Common Questions</h1>
          <p className={styles.subtitle}>
            Everything you need to know about the product, privacy, and planning.
          </p>
        </div>
      </header>

      <section className={styles.faqSection}>
        <div className={styles.container}>
          {faqs.map((group, groupIndex) => (
            <div key={groupIndex} className={styles.categoryBlock}>
              <h2 className={styles.categoryTitle}>{group.category}</h2>
              <div className={styles.accordion}>
                {group.questions.map((faq, qIndex) => {
                  const absoluteIndex = `${groupIndex}-${qIndex}`;
                  const isOpen = openIndex === absoluteIndex;

                  return (
                    <div 
                      key={qIndex} 
                      className={`${styles.accordionItem} ${isOpen ? styles.open : ''}`}
                    >
                      <button 
                        className={styles.accordionHeader} 
                        onClick={() => toggleAccordion(absoluteIndex)}
                      >
                        <h3>{faq.q}</h3>
                        <span className={styles.icon}>{isOpen ? '−' : '+'}</span>
                      </button>
                      <div 
                        className={styles.accordionContent}
                        style={{ maxHeight: isOpen ? '500px' : '0' }}
                      >
                        <p>{faq.a}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </section>
      
      {/* Contact Prompt Footer */}
      <section className={styles.contactPrompt}>
        <div className={styles.container}>
          <h2>Still have questions?</h2>
          <p>We're here to help you get the most out of your week.</p>
          <a href="/contact" className={styles.contactBtn}>Contact Support</a>
        </div>
      </section>
    </div>
  );
};

export default FAQPage;